export default __webpack_public_path__ + "static/media/loading.86214682.gif";